import { IProjectData } from "../../types/projectData.types"

export enum ProjectActionType {
  FETCH_PROJECT_DATA = "FETCH_PROJECT_DATA",
  FETCH_PROJECT_DATA_SUCCESS = "FETCH_PROJECT_DATA_SUCCESS",
  FETCH_PROJECT_DATA_ERROR = "FETCH_PROJECT_DATA_ERROR",
}

interface FetchProjects {
  type: ProjectActionType.FETCH_PROJECT_DATA
}

interface FetchProjectsSuccess {
  type: ProjectActionType.FETCH_PROJECT_DATA_SUCCESS
  payload: IProjectData[]
}

interface FetchProjectsError {
  type: ProjectActionType.FETCH_PROJECT_DATA_ERROR
  payload: string
}

export type ProjectAction = FetchProjects | FetchProjectsSuccess | FetchProjectsError

export interface IProjectState {
  projectData: IProjectData[]
  loading: boolean
  error: string | null
}
